import React, { useEffect, useRef, useState } from 'react';
import { LuLanguages } from 'react-icons/lu';
import { LANGUAGE_OPTIONS } from '../i18n/translations';
import { useLanguage } from '../i18n/LanguageContext';
import './LanguageToggle.css';

export default function LanguageToggle({ variant = 'topbar' }) {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className={`lang-toggle lang-toggle--${variant}`} ref={wrapRef}>
      <button
        type="button"
        className="lang-toggle__btn"
        aria-label={t('lang.switch')}
        aria-expanded={open}
        aria-haspopup="true"
        title={t('lang.switch')}
        onClick={() => setOpen((o) => !o)}
      >
        {variant === 'compact' ? (
          <LuLanguages className="lang-toggle__btn-icon" aria-hidden size={18} strokeWidth={2.25} />
        ) : null}
        <span className="lang-toggle__code">{lang === 'sw' ? 'SW' : 'EN'}</span>
      </button>
      {open ? (
        <div className="lang-toggle__panel" role="menu" aria-label={t('lang.label')}>
          <div className="lang-toggle__panel-head">{t('lang.label')}</div>
          {LANGUAGE_OPTIONS.map((opt) => {
            const active = lang === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                role="menuitemradio"
                aria-checked={active}
                className={`lang-toggle__option${active ? ' is-active' : ''}`}
                onClick={() => {
                  void setLang(opt.value);
                  setOpen(false);
                }}
              >
                <span className="lang-toggle__option-label">{t(opt.labelKey)}</span>
                <span className="lang-toggle__option-code" aria-hidden>
                  {opt.value === 'sw' ? 'SW' : 'EN'}
                </span>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
